import React, {useEffect, useState} from 'react';
import {Label} from '../../pages/about/register';
import {Button, DatePicker, Input, message, Modal, Radio, Select, Space, Tooltip} from 'antd';
import {useInput} from 'react-hanger';
import moment, {Moment} from 'moment';
import Text from 'antd/lib/typography/Text';
import UploadImage from '../UploadImage';
import TextArea from 'antd/lib/input/TextArea';
import './congress.less';
import {useOpenApiFpRequest} from '../../Http/useOpenApiRequest';
import {CongressTable, CongressTableApi, UserApi} from '../../scaffold';
import CountDownButton from '../CountDownButton';
import CommonApiErrorHandler from '../../utils/HttpInstance';

export default function CongressTableEditForm(props: {onSuccess?: (p: CongressTable) => any; loading?: boolean; table?: CongressTable; suMode?: boolean}) {
  const name = useInput('');
  const gender = useInput('');
  const [birthDate, setBirthDate] = useState<Moment>();
  const job = useInput('');
  const organizationName = useInput('');
  const organizationJob = useInput('');
  const organizationAddress = useInput('');
  const workDepartment = useInput('');
  const workTitle = useInput('');
  const email = useInput('');
  const telephone = useInput('');
  const fax = useInput('');
  const postcode = useInput('');
  const phone = useInput('');
  const advice = useInput('');
  const verifyCode = useInput('');
  const source = useInput('当然代表');
  const requestSms = useOpenApiFpRequest(UserApi, UserApi.prototype.userRequestSmsCodePost);
  const submitHook = useOpenApiFpRequest(CongressTableApi, CongressTableApi.prototype.congressTableSubmitPost);
  const saveHook = useOpenApiFpRequest(CongressTableApi, CongressTableApi.prototype.congressTableSavePost);

  function refresh() {
    name.setValue(props.table?.name || '');
    gender.setValue(props.table?.gender || '');
    setBirthDate(props.table?.birthDate ? moment(props.table?.birthDate) : undefined);
    job.setValue(props.table?.job || '');
    organizationName.setValue(props.table?.organizationName || '');
    organizationJob.setValue(props.table?.organizationJob || '');
    organizationAddress.setValue(props.table?.organizationAddress || '');
    workDepartment.setValue(props.table?.workDepartment || '');
    workTitle.setValue(props.table?.workTitle || '');
    email.setValue(props.table?.email || '');
    telephone.setValue(props.table?.telephone || '');
    fax.setValue(props.table?.fax || '');
    postcode.setValue(props.table?.postcode || '');
    phone.setValue(props.table?.phone || '');
    advice.setValue(props.table?.advice || '');
    verifyCode.setValue('');
    source.setValue(props.table?.source || '当然代表');
  }

  useEffect(() => {
    refresh();
  }, [props.table]);

  function submit() {
    submitHook
      .request({
        submitCongressTableParams: {
          name: name.value,
          gender: gender.value,
          birthDate: birthDate?.format('YYYY-MM-DD') || '',
          job: job.value,
          organizationName: organizationName.value,
          organizationJob: organizationJob.value,
          organizationAddress: organizationAddress.value,
          workDepartment: workDepartment.value,
          workTitle: workTitle.value,
          email: email.value,
          telephone: telephone.value,
          fax: fax.value,
          postcode: postcode.value,
          phone: phone.value,
          advice: advice.value,
          verifyCode: verifyCode.value,
          source: source.value,
        },
      })
      .then(res => {
        props.onSuccess && props.onSuccess(res);
        refresh();
        Modal.confirm({title: '提交成功'});
      })
      .catch(CommonApiErrorHandler);
  }

  function save() {
    saveHook
      .request({
        saveCongressTableParams: {
          id: props.table?.id || 0,
          name: name.value,
          gender: gender.value,
          birthDate: birthDate?.format('YYYY-MM-DD') || '',
          job: job.value,
          organizationName: organizationName.value,
          organizationJob: organizationJob.value,
          organizationAddress: organizationAddress.value,
          workDepartment: workDepartment.value,
          workTitle: workTitle.value,
          email: email.value,
          telephone: telephone.value,
          fax: fax.value,
          postcode: postcode.value,
          phone: phone.value,
          advice: advice.value,
          source: source.value,
        },
      })
      .then(res => {
        props.onSuccess && props.onSuccess(res);
        refresh();
        Modal.confirm({title: '保存成功'});
      })
      .catch(CommonApiErrorHandler);
  }

  return (
    <table className={'CongressTable'}>
      <tbody>
        <tr>
          <td width={100}>
            <Label required>名额来源</Label>
          </td>
          <td>
            <Select value={source.value} onChange={e => source.setValue(e)}>
              <Select.Option value={'当然代表'}>当然代表</Select.Option>
              <Select.Option value={'会员单位'}>会员单位</Select.Option>
              <Select.Option value={'专委会'}>专委会</Select.Option>
            </Select>
          </td>
          <td width={100}>
            <Label required>姓名</Label>
          </td>
          <td>
            <Input {...name.eventBind} />
          </td>
          <td width={70}>
            <Label required>性别</Label>
          </td>
          <td>
            <Input {...gender.eventBind} />
          </td>
          <td width={100}>
            <Label>出生年月</Label>
          </td>
          <td>
            <DatePicker value={birthDate} onChange={e => setBirthDate(e as Moment)} style={{width: '100%'}} />
          </td>
        </tr>
        <tr>
          <td>
            <Label required>学会职务</Label>
          </td>
          <td>
            <Input {...job.eventBind} />
          </td>
          <td>
            <Label required>工作单位</Label>
          </td>
          <td colSpan={3}>
            <Input {...organizationName.eventBind} />
          </td>
          <td>
            <Label required>单位职务</Label>
          </td>
          <td>
            <Input {...organizationJob.eventBind} />
          </td>
        </tr>
        <tr>
          <td>
            <Label required>工作部门</Label>
          </td>
          <td colSpan={3}>
            <Input {...workDepartment.eventBind} />
          </td>
          <td>
            <Label required>技术职称</Label>
          </td>
          <td colSpan={3}>
            <Input {...workTitle.eventBind} />
          </td>
        </tr>
        <tr>
          <td>
            <Label required>单位地址</Label>
          </td>
          <td colSpan={3}>
            <Input {...organizationAddress.eventBind} />
          </td>
          <td>
            <Label required>电子邮件</Label>
          </td>
          <td colSpan={3}>
            <Input {...email.eventBind} />
          </td>
        </tr>
        <tr>
          <td>
            <Label>电话</Label>
          </td>
          <td colSpan={3}>
            <Input {...phone.eventBind} />
          </td>
          <td>
            <Label>传真</Label>
          </td>
          <td>
            <Input {...fax.eventBind} />
          </td>
          <td>
            <Label>邮编</Label>
          </td>
          <td>
            <Input {...postcode.eventBind} />
          </td>
        </tr>
        <tr>
          <td colSpan={8} className={'text-left'}>
            <p>请您对下述几个方面提出宝贵意见：</p>
            <p>1、对学会的工作、改革和发展有何建议？</p>
            <p> 2、怎样丰富学术活动的内容和创新活动形式以满足会员的需要？</p>
            <p> 3、您对学会科普和咨询工作的建议？</p>
            <p> 4、本单位能对学会工作提供什么帮助和支持？</p>
            <TextArea {...advice.eventBind} rows={7} />
          </td>
        </tr>
        {!props.suMode && (
          <tr>
            <td>
              <Label required>手机</Label>
            </td>
            <td colSpan={3}>
              <Input {...telephone.eventBind} />
            </td>
            <td>
              <Label required>验证码</Label>
            </td>
            <td colSpan={3}>
              <Space>
                <Input {...verifyCode.eventBind} />
                <CountDownButton
                  title={'立即获取'}
                  loading={requestSms.loading}
                  onClick={() => requestSms.request({requestSmsCodeParams: {telephone: telephone.value}})}
                  countDown={60}
                />
              </Space>
            </td>
          </tr>
        )}

        <tr>
          <td colSpan={8}>
            {props.suMode ? (
              <Button onClick={save} loading={saveHook.loading} type={'primary'}>
                保存
              </Button>
            ) : (
              <Button onClick={submit} loading={submitHook.loading} type={'primary'}>
                提交
              </Button>
            )}
          </td>
        </tr>
      </tbody>
    </table>
  );
}
